import { render, staticRenderFns } from "./AgentClassificationLabelComponent.vue?vue&type=template&id=7be435f1&scoped=true&"
import script from "./AgentClassificationLabelComponent.vue?vue&type=script&lang=js&"
export * from "./AgentClassificationLabelComponent.vue?vue&type=script&lang=js&"
import style0 from "./AgentClassificationLabelComponent.vue?vue&type=style&index=0&id=7be435f1&prod&scoped=true&lang=css&"
import style1 from "./AgentClassificationLabelComponent.vue?vue&type=style&index=1&id=7be435f1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7be435f1",
  null
  
)

export default component.exports